/**
 *
 * DashboardSecuritySettings
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";

import { UserInfo } from "types/UserInfo";
import withAuth from "utils/withAuth";
import Layout from "./layout";
import selectDashboardSecuritySettingsDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";

const mapStateToProps = selectDashboardSecuritySettingsDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  {} // own props type
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: "dashboardSecuritySettings",
  reducer,
});
const withSaga = injectSaga({
  key: "dashboardSecuritySettings",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga,
  withAuth({ route: "/dashboard/securitysettings" })
)(
  Layout as React.ComponentType<
    ConnectedProps<typeof withConnect & { userInfo: UserInfo }>
  >
);
